module.exports = __webpack_public_path__ + "img/715.0bf586ba.jpg";